const DB_NAME = 'rehabitaire-recordings';
const DB_VERSION = 1;
const STORE_NAME = 'videos';
const RECORDING_KEY = 'latest-recording';

function openDatabase() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error || new Error('Failed to open recordings database.'));
  });
}

function runTransaction(mode, handler) {
  return openDatabase().then(
    db =>
      new Promise((resolve, reject) => {
        const transaction = db.transaction(STORE_NAME, mode);
        const store = transaction.objectStore(STORE_NAME);
        const request = handler(store);

        transaction.oncomplete = () => {
          db.close();
          resolve(request?.result);
        };

        transaction.onerror = () => {
          db.close();
          reject(transaction.error || request?.error || new Error('IndexedDB transaction failed.'));
        };

        transaction.onabort = () => {
          db.close();
          reject(transaction.error || new Error('IndexedDB transaction aborted.'));
        };
      })
  );
}

export function saveRecordedVideo(payload) {
  if (!payload?.blob || !payload?.fileName) {
    return Promise.resolve(false);
  }

  return runTransaction('readwrite', store => store.put(payload, RECORDING_KEY)).then(() => true);
}

export function getRecordedVideo() {
  return runTransaction('readonly', store => store.get(RECORDING_KEY)).then(result => result ?? null);
}

export function clearRecordedVideo() {
  return runTransaction('readwrite', store => store.delete(RECORDING_KEY)).then(() => true);
}
